<!-- Start Subscribe Area -->
<section class="subscribe-area" style="text-align: center;">
    <div class="container" style="max-width: 80%;" *ngIf="router.url === '/join-us'">
        <div style="width: 100%;">
            <div style="padding-top: 110px;padding-bottom: 110px;">
                <div class="newsletter-content">
                    <!-- <h2>工作機會列表</h2> -->
                    <a href="https://www.104.com.tw/company/1a2x6bkrpw" target="_blank">
                        <!-- <h2 style="word-break: break-word;">https://www.104.com.tw/company/1a2x6bkrpw</h2> -->
                        <img class="job" src="assets/img/join-us/icon30.png">
                    </a>
                </div>
            </div>

            <!-- <div class="col-lg-7 col-md-12">
                <div class="subscribe-contact-info" style="height: 259px;">
                    <img src="assets/img/woman.png" alt="image">

                    <div class="content">
                        <h2>Have any questions?</h2>
                        <span>Call: <a href="tel:+440458954">+440458954</a></span>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
    <div class="container" style="max-width: 80%;margin-left: 0;padding-left: 0;" *ngIf="router.url !== '/join-us'">
        <div style="width: 100%;">
            <div style="padding-top: 30px;">
                <div class="newsletter-content">
                    <form class="newsletter-form" data-toggle="validator" style="text-align: left;width: 60%;">
                        <input type="name" class="input-newsletter" placeholder="Enter your name" name="name" required autocomplete="off" [(ngModel)]="name">
                        <br>
                        <input type="email" class="input-newsletter" placeholder="Enter your email address" name="EMAIL" required autocomplete="off" [(ngModel)]="email">
                        <br>
                        <button type="submit" style="position:relative;border-radius:5px;" (click)="subscribe()">Subscribe <i class="flaticon-paper-plane"></i></button>
                        <!-- <button type="submit">Subscribe <i class="flaticon-paper-plane"></i></button> -->
                        <!-- <div id="validator-newsletter" class="form-result"></div> -->
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div style="width: 100%;height: 100%;position: fixed;background-color: #dedede;z-index: 999;top: 0;left: 0;opacity: 0.5;" *ngIf="loading"></div>
    <div class="spinner-border load-spinner" role="status" *ngIf="loading">
        <span class="sr-only">Loading...</span>
    </div>
</section>
<!-- End Subscribe Area -->